module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(3), exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var style_1 = __webpack_require__(4);
var React = __webpack_require__(1);
var styles = __webpack_require__(5);
var sync_1 = __webpack_require__(6);
exports.ButtonSize = {
    L: 'L',
    M: 'M',
    S: 'S',
    XS: 'XS',
};
exports.ButtonTheme = {
    Default: 'default',
    Ghost: 'ghost',
};
exports.ButtonColor = {
    Danger: 'danger',
    Primary: 'primary',
};
var syncSizes;
(function (syncSizes) {
    syncSizes[syncSizes["S"] = 16] = "S";
    syncSizes[syncSizes["L"] = 18] = "L";
})(syncSizes = exports.syncSizes || (exports.syncSizes = {}));
var Button = /** @class */ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a = this.props, block = _a.block, children = _a.children, color = _a.color, size = _a.size, theme = _a.theme, isSync = _a.isSync, textClassName = _a.textClassName, syncClassName = _a.syncClassName, isIconButton = _a.isIconButton, dataMark = _a.dataMark, sharedProps = tslib_1.__rest(_a, ["block", "children", "color", "size", "theme", "isSync", "textClassName", "syncClassName", "isIconButton", "dataMark"]);
        var isSyncSmall = size === exports.ButtonSize.S || size === exports.ButtonSize.XS;
        var syncSize = isSyncSmall ? syncSizes.S : syncSizes.L;
        return (React.createElement("button", tslib_1.__assign({}, sharedProps, style_1.mergeStyles([
            styles['button'],
            styles[size],
            styles[theme],
            styles[color],
            block && styles['block'],
            isSync && styles['syncing'],
            isIconButton && styles['icon-button'],
            this.props.className,
            this.props.style,
        ]), { "data-mark": dataMark }),
            React.createElement("span", tslib_1.__assign({}, style_1.mergeStyles([
                styles['button-text'],
                textClassName,
            ])), children),
            React.createElement(sync_1.IconSync, tslib_1.__assign({}, style_1.mergeStyles([
                styles['sync'],
                isSyncSmall && styles['sync-small'],
                syncClassName,
            ]), { size: syncSize }))));
    };
    Button.defaultProps = {
        color: exports.ButtonColor.Primary,
        size: exports.ButtonSize.S,
        theme: exports.ButtonTheme.Default,
    };
    return Button;
}(React.PureComponent));
exports.Button = Button;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isStyleProps(styleArgument) {
    if (typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
var reduce = function (acc, style) {
    if (typeof style === 'string') {
        acc.className += acc.className.length === 0
            ? style
            : " " + style;
    }
    else if (typeof style === 'object') {
        if (isStyleProps(style)) {
            acc.className += acc.className.length === 0
                ? style.className
                : " " + style.className;
            Object.assign(acc.style, style.style);
        }
        else if (Array.isArray(style)) {
            return style.reduce(reduce, acc);
        }
        else {
            Object.assign(acc.style, style);
        }
    }
    return acc;
};
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reduce, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;
//# sourceMappingURL=style.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button_component-button-i4Ewq4mdwsm","XS":"button_component-XS-eR7JbeygLKg","icon-button":"button_component-icon-button-eR4QwSNYzY","S":"button_component-S-iYh7kZ6fokS","M":"button_component-M-7pqplWQoxOy","L":"button_component-L-coq1wRZFYcu","default":"button_component-default-9eCiavb5DOo","primary":"button_component-primary-5V2wwnUSaIM","danger":"button_component-danger-jmpTgUdF16k","ghost":"button_component-ghost-giYNnqSmNUo","button-text":"button_component-button-text-bV5rklu7fy0","block":"button_component-block-1L6yfuY1KAm","sync":"button_component-sync-juEb7eFQo8M","sync-small":"button_component-sync-small-5C6wmEI2Huu","syncing":"button_component-syncing-7bCplTBU1aw","button_sync_animation":"button_component-button_sync_animation-4bgFB4GxXOo"};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
exports.IconSync = function (props) { return (React.createElement("svg", { style: props.style || {}, className: props.className || '', xmlns: "http://www.w3.org/2000/svg", width: props.size, height: props.size, viewBox: "0 0 16 16" },
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 16a8.008 8.008 0 0 1-8-8h2.134A5.866 5.866 0 1 0 8 2.133V0a8 8 0 1 1 0 16z" }))); };


/***/ })
/******/ ]);
//# sourceMappingURL=frontend-button-component.js.map